import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69e47d638485e20014242167/vesselaudit/src/app/inspection-application/components/InspectionApplicationClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69e47d638485e20014242167/vesselaudit/src/components/AppLayout.tsx");
